import React from "react";
import { Row, Col } from "react-bootstrap";
import EventlogCard from "./EventlogCard";
import "./Styles/eventlog.scss";

import Droid from "../Assets/Images/icons8-droid-48.png"

const Eventlog = (props) => {
  const { eventLog = [] } = props;
  return (
    <Col className="eventlog-container col-md-12">
      <h3 className="section-title-dash">Event Log</h3>
      <div className="eventlog-events">
        {eventLog.map((x, index) => (
          <Col className="col-md-12" key={"event_log_" + index + "_" + x.id}>
            <EventlogCard {...x} />
          </Col>
        ))}
        {(eventLog == null || eventLog.length == 0) && <div className="logs-empty"><img src={Droid} /> Don't worry. Logs will show up as you go. </div>}
      </div>
    </Col>
  );
};
export default Eventlog;
